import React, { useEffect, useState } from 'react'
// Ant Design
import { Flex, Typography } from 'antd'
// i18
import { useTranslation } from 'react-i18next'

const { Text } = Typography

export const Card = ({graph, size}) => {
    const { t } = useTranslation(["translation"])
    const [title, setTitle] = useState("")
    const [value, setValue] = useState("")

    useEffect(() => {
        if (graph) {
            if(graph.channel) {
                setTitle(graph.title)
                setValue(graph.fields[graph.channel][0].value)
            }
            else {
                setTitle(graph.title)
                setValue(graph.fields[0].value)
            }
        }
        else {
            setTitle(t("example_card"))
            setValue("100")
        }
    }, [graph])

    return (
        <Flex justify="center" align="center" style={{ width: "85%", height: "80%", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
            <Flex style={{ width: size==="lg" ? "60%" : "90%", height: size==="lg" ? "40%" : "90%", borderRadius: "10px", backgroundColor: "#FFFFFF", padding: "20px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)" }}>
                <Flex style={{ width: "100%", height: "100%", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                    <Text style={{ fontSize: size==="lg" ? "26px" : "20px", fontWeight: "bold", color: "#333333", textAlign: "center" }}>{title}</Text>
                    <Text level={2} style={{ fontSize: size==="lg" ? "40px" : "26px", color: "green", marginTop: "10px" }}>{value}</Text>
                </Flex>
            </Flex>
        </Flex>
    )
}
